import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustIndicators = () => {
  const trustFeatures = [
    {
      icon: 'Shield',
      title: 'Secure Login',
      description: 'SSL encrypted authentication'
    },
    {
      icon: 'Lock',
      title: 'Privacy Protected',
      description: 'Your data is safe with us'
    },
    {
      icon: 'Award',
      title: 'Trusted by 50K+',
      description: 'Beauty enthusiasts worldwide'
    }
  ];

  return (
    <div className="mt-8 p-6 bg-card rounded-xl border border-border">
      <div className="text-center mb-4">
        <h3 className="text-lg font-heading font-semibold text-foreground mb-2">
          Why Choose Bounderlaster?
        </h3>
        <p className="text-sm text-muted-foreground">
          Join thousands of beauty lovers who trust us with their skincare journey
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {trustFeatures?.map((feature, index) => (
          <div key={index} className="text-center">
            <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-3">
              <Icon name={feature?.icon} size={24} className="text-primary" />
            </div>
            <h4 className="text-sm font-medium text-foreground mb-1">
              {feature?.title}
            </h4>
            <p className="text-xs text-muted-foreground">
              {feature?.description}
            </p>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border text-center">
        <div className="flex items-center justify-center space-x-4 text-xs text-muted-foreground">
          <div className="flex items-center space-x-1">
            <Icon name="Shield" size={14} className="text-success" />
            <span>SSL Secured</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="Eye" size={14} className="text-primary" />
            <span>Privacy Policy</span>
          </div>
          <div className="flex items-center space-x-1">
            <Icon name="FileText" size={14} className="text-secondary" />
            <span>Terms of Service</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustIndicators;